import LoadingIcon from "components/Loading/LoadingIcon";
import Swimlane, { SwimlaneItem } from "components/Swimlane/Swimlane";
import type { Metadoc } from "services/metadoc-api";

type MetaDocProcessingScreenProps = {
  metadoc?: Metadoc;
};

const MetaDocProcessingScreen = ({ metadoc }: MetaDocProcessingScreenProps) => {
  const statusMessage =
    metadoc?.status === "pending"
      ? "Queued for processing..."
      : metadoc?.status === "processing"
        ? "Pre-processing Documents..."
        : "Creating meta document...";

  return (
    <Swimlane>
      <SwimlaneItem heading="Meta Document">
        <div className="metadoc-processing-state">
          <div className="metadoc-processing-content">
            <p className="metadoc-processing-message">{statusMessage}</p>
            <p className="metadoc-processing-detail">
              You can navigate away - you will be notified when the meta
              document is complete
            </p>
            <LoadingIcon size="large" showText={false} />
          </div>
        </div>
      </SwimlaneItem>
    </Swimlane>
  );
};

export default MetaDocProcessingScreen;
